export default __webpack_public_path__ + "static/media/Zine Affiliate Training Guide.cfe66c73.pdf";